import React from 'react';
import Avatar from '../components/Avatar';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import * as styles from './UserRow.module.scss';
import UserBadge from './profile/UserBadge';
import { useGetUser } from './useAllUsers';

const USER_ROW_USER_FRAGMENT = gql(`
  fragment UserRow_user on User {
    id
    ...useGetUser_user
  }
`);

interface UserRowProps {
  showBadge?: boolean;
  user: DocumentType<typeof USER_ROW_USER_FRAGMENT>;
  avatarSize?: React.ComponentProps<typeof Avatar>['size'];
}

const UserRow = ({ showBadge = false, user, avatarSize }: UserRowProps) => {
  const getUser = useGetUser();
  const fullUser = getUser(user);

  return (
    <div className={styles.innerContainer}>
      <div className={styles.avatarContainer}>
        <Avatar user={fullUser} size={avatarSize} />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.nameContainer}>
          <div className={styles.name}>{fullUser.name}</div>
          {showBadge && (
            <div className={styles.badgeContainer}>
              <UserBadge user={fullUser} />
            </div>
          )}
        </div>
        {fullUser.title && <div className={styles.title}>{fullUser.title}</div>}
      </div>
    </div>
  );
};

export default UserRow;
